import ButtonCircle from './ButtonCircle';
import Tag from './Tag/Tag';
import { type TagProps } from './Tag/Tag.types';

export type LinkTileProps = {
  extraClass?: string;
  title: string;
  subtitle?: any;
  selectedTag?: string;
  content: string;
  externalLink?: string;
  link: string;
  headingSize?: string;
  position: number;
  tag?: TagProps;
  includeArticleMetadata?: boolean;
  useTagAsSubtitle?: boolean;
  credits?: string;
  publishDate?: string;
  disableCard?: boolean;
};

const LinkTile: React.FC<LinkTileProps> = ({
  extraClass,
  title,
  selectedTag,
  content,
  externalLink,
  link,
  subtitle,
  headingSize,
  position,
  tag,
  includeArticleMetadata,
  useTagAsSubtitle,
  credits,
  publishDate,
  disableCard,
}) => {
  const url = externalLink || link;
  const TileTag = url ? 'a' : 'div';
  const defaultHeadingSize = 'h4';
  const pos = `${position}00`;
  subtitle = useTagAsSubtitle ? selectedTag : subtitle;
  const disableCardClass = disableCard ? 'link-tile--link' : '';

  return (
    <div
      className="link-tile__outer"
      data-aos="fade-up"
      data-aos-delay={pos}
      data-aos-duration="400"
    >
      <TileTag
        className={`link-tile ${disableCardClass} ${extraClass}`}
        href={url || ''}
        data-testid="LinkTile--{$ID}"
      >
        {tag && <Tag {...tag} />}
        {subtitle && <div className="link-tile__subtitle h6">{subtitle}</div>}
        {title && (
          <div
            className={`link-tile__title ${headingSize || defaultHeadingSize}`}
          >
            {title}
          </div>
        )}

        {includeArticleMetadata && (
          <p className="link-tile__metadata">
            {credits}
            <span className="link-tile__metadata-separator">&#8226;</span>
            {publishDate}
          </p>
        )}

        {content && (
          <div
            className="link-tile__summary"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
        {url && (
          <span className="link-tile__button button--secondary-alt">
            <ButtonCircle
              arrowHeight={17}
              arrowWidth={21}
              arrowFill="#ffffff"
            />
          </span>
        )}
      </TileTag>
    </div>
  );
};

export default LinkTile;
